import React from "react"

/** The seven glyphs the design puts beside its KPI labels, one per metric. */

type IconProps = React.SVGProps<SVGSVGElement>

const Glyph = ({ children, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    {children}
  </svg>
)

export const PeopleIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M16 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1" />
    <circle cx="9" cy="7" r="3" />
    <path d="M22 19v-1a4 4 0 0 0-3-3.87" />
    <path d="M16 4.13a4 4 0 0 1 0 7.75" />
  </Glyph>
)

export const FlameIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M12 2c1.5 4-1 5-2.5 7.5-1.5 2.5-1 5 1 6.5 2 1.5 5.5 1 7-2 1.5-3 0-6-2-8 0 3-1.5 4-2.5 4.5.5-3 0-5.5-1-8.5z" />
  </Glyph>
)

export const FunnelIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M3 4h18l-7 8v6l-4 2v-8z" />
  </Glyph>
)

export const ClockIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Glyph>
)

export const XCircleIcon = (props: IconProps) => (
  <Glyph {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15 9l-6 6M9 9l6 6" />
  </Glyph>
)

export const ExchangeIcon = (props: IconProps) => (
  <Glyph {...props}>
    <path d="M3 8h14l-3-3M21 16H7l3 3" />
  </Glyph>
)

export const LEAD_KPI_ICONS = {
  people: PeopleIcon,
  flame: FlameIcon,
  funnel: FunnelIcon,
  clock: ClockIcon,
  xcircle: XCircleIcon,
  exchange: ExchangeIcon
} as const

export type LeadKpiIconKey = keyof typeof LEAD_KPI_ICONS
